import { render, staticRenderFns } from "./BatchPayDetailModal.vue?vue&type=template&id=0b6e4a98&scoped=true"
import script from "./BatchPayDetailModal.vue?vue&type=script&lang=js"
export * from "./BatchPayDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BatchPayDetailModal.vue?vue&type=style&index=0&id=0b6e4a98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e4a98",
  null
  
)

export default component.exports